import { render, staticRenderFns } from "./StonePatterns.vue?vue&type=template&id=1adb13b6&scoped=true&"
import script from "./StonePatterns.vue?vue&type=script&lang=js&"
export * from "./StonePatterns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adb13b6",
  null
  
)

export default component.exports